import React from 'react';
import useMediaQuery from '../hooks/useMediaQuery';
import {MultiOption, SingleOption} from '../types/question';
import Div from './Div.styled';
import SpaceLike from './Space';
import TypographyBody from './Typography/TypographyBody';

type MultiOptionProps = {
  selectedOptions: SingleOption[] | MultiOption[];
  handleOptionChange: (option: SingleOption | MultiOption) => void;
};

const MultiOptions: React.FC<MultiOptionProps> = ({
  selectedOptions,
  handleOptionChange,
}) => {
  const {isMobile} = useMediaQuery();
  return (
    <Div
      customStyles={{
        margin: '0 auto',
        position: 'relative',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <SpaceLike
        customStyles={{
          textAlign: 'center',
          width: '100%',
        }}
        className="no-scroll"
        size={16}
        direction="vertical"
      >
        {selectedOptions.map((option, i) => (
          <TypographyBody
            key={i}
            onClick={() =>
              option.isDisabled ? undefined : handleOptionChange(option)
            }
            size="body"
            textAlign="center"
            color="white"
            style={{
              fontWeight: '400',
              padding: '16px 40px',
              width: isMobile ? '326px' : '400px',
              borderRadius: 40,
              border: option.isDisabled
                ? '2px solid rgba(194,202,207,0.2)'
                : option.isSelect
                ? '2px solid var(--1-white-000, #FFF)'
                : '2px solid rgba(255, 255, 255, 0.35);',
              cursor: option.isDisabled ? 'not-allowed' : 'pointer',
              position: 'relative',
              zIndex: option.isSelect ? '1' : '0',
              margin: '0 auto',
              opacity: option.isDisabled ? 0.35 : 1,
            }}
            hoverStyles={{
              opacity: option.isDisabled ? 0.35 : option.isSelect ? 1 : 0.5,
            }}
          >
            {option.label}
          </TypographyBody>
        ))}
      </SpaceLike>
    </Div>
  );
};

export default MultiOptions;
